import React from 'react';
import { object } from 'prop-types';
import { EducationTooltip } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/fiverr_context';

import './index.scss';

const withEducationTooltip = (TriggerComponent) => {
    const EducationTooltipWrapper = ({ educationTooltip, ...props }) => {

        if (!educationTooltip) {
            return <TriggerComponent {...props}/>;
        }

        const { title, body, tooltipStorageKey, ...tooltipProps } = educationTooltip;

        return (
            <EducationTooltip className="collect-package-education"
                boxClassName="collect-education-tooltip-box"
                title={title}
                body={body}
                tooltipStorageKey={tooltipStorageKey}
                badgeTitle={<I18n k="collect_package.tooltips.new"/>}
                closeTitle={<I18n k="collect_package.tooltips.got_it"/>}
                position={EducationTooltip.POSITIONS.TOP_LEFT}
                {...tooltipProps}>
                <TriggerComponent {...props}/>
            </EducationTooltip>
        );
    };

    EducationTooltipWrapper.propTypes = {
        educationTooltip: object
    };

    return EducationTooltipWrapper;
};

export default withEducationTooltip;
